export default function ButtonLogoGitHub() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00005 1.59998C4.46588 1.59998 1.60001 4.53774 1.60001 8.16195C1.60001 11.0612 3.43382 13.521 5.97675 14.3887C6.29662 14.4495 6.41404 14.2464 6.41404 14.073C6.41404 13.9165 6.40811 13.3996 6.40534 12.8513C4.62486 13.2483 4.24913 12.0771 4.24913 12.0771C3.958 11.3186 3.53853 11.1169 3.53853 11.1169C2.95785 10.7096 3.5823 10.718 3.5823 10.718C4.22497 10.7642 4.56337 11.3942 4.56337 11.3942C5.13417 12.3974 6.06059 12.1074 6.42578 11.9397C6.48325 11.5157 6.64909 11.226 6.83213 11.0622C5.41061 10.8963 3.91625 10.3336 3.91625 7.81923C3.91625 7.10278 4.16626 6.51739 4.57566 6.05785C4.50922 5.89247 4.29014 5.22514 4.63766 4.32128C4.63766 4.32128 5.17509 4.14492 6.39813 4.99391C6.90868 4.84853 7.45618 4.77558 8.00005 4.77313C8.54396 4.77558 9.09189 4.84853 9.60333 4.99391C10.8249 4.14492 11.3616 4.32128 11.3616 4.32128C11.71 5.22514 11.4908 5.89247 11.4243 6.05785C11.8347 6.51739 12.083 7.10278 12.083 7.81923C12.083 10.3396 10.5858 10.8946 9.16067 11.057C9.39026 11.2607 9.59476 11.66 9.59476 12.2722C9.59476 13.1501 9.58733 13.8568 9.58733 14.073C9.58733 14.2477 9.70253 14.4523 10.027 14.3878C12.5685 13.5192 14.4 11.0603 14.4 8.16195C14.4 4.53774 11.5346 1.59998 8.00005 1.59998Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.5082 8.39494C2.49866 8.41689 2.46479 8.42339 2.43393 8.40834C2.40251 8.39396 2.38485 8.36411 2.39504 8.34216C2.40437 8.3196 2.43831 8.31338 2.46967 8.32835C2.50117 8.34282 2.51911 8.37295 2.5082 8.39494Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.68112 8.59385C2.66045 8.61332 2.62005 8.60428 2.59264 8.57348C2.56429 8.54274 2.55898 8.50167 2.57993 8.48188C2.60125 8.46238 2.64043 8.47151 2.66884 8.50224C2.69719 8.53333 2.70272 8.57412 2.68112 8.59385Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.85332 8.84761C2.82677 8.86636 2.78335 8.84876 2.75651 8.80959C2.72997 8.77039 2.72997 8.72339 2.75709 8.70455C2.78401 8.68572 2.82677 8.70264 2.85398 8.74156C2.88044 8.78134 2.88044 8.8284 2.85332 8.84761Z"
        fill="currentColor"
      />
    </svg>
  );
}
